<template>
  <div class="mt-5">
    <h2>Send en ny melding</h2>
    <b-form @submit.prevent="onSubmit">
      <b-form-group id="subject" label="Emne" label-for="subject">
        <b-form-input
          id="subject"
          v-model="form.subject"
          type="text"
          required
          placeholder="Gjeldende bookingsystem.."
        ></b-form-input>
      </b-form-group>

      <b-form-group id="content" label="Melding" label-for="message">
        <b-form-textarea
          id="message"
          v-model="form.message"
          type="text"
          required
          placeholder="Hei, jeg lurer på..."
        ></b-form-textarea>
      </b-form-group>

      <b-button type="submit" variant="primary">Send</b-button>
    </b-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      form: {
        subject: '',
        message: '',
      },
    };
  },
  methods: {
    ...mapActions({
      createThread: 'messages/createThread',
    }),
    onSubmit() {
      this.createThread(this.form);
    },
  },
};
</script>

<style>
</style>
